var instance = new Layzr();
document.addEventListener('DOMContentLoaded', function (event) {
    document.body.className += ' load-complete';

    if(document.getElementById('smm') !== null) {
        setTimeout(function(){
            document.body.className += ' no-smm';
        }, 7500);
    }

    instance
        .update()           // track initial elements
        .check()            // check initial elements
        .handlers(true);    // bind scroll and resize handlers
});

//const viewPopup = Cookies.get('name');
//
//if(viewPopup !== 'undefined') {
//    console.log('all good');
//} else {
//    console.log(viewPopup);
//}

(function ($) {

    var $window, $body, $gallery, sliderCounts, $lightBox, lightBoxView, lightBoxList, $searchBox, $homeSlider, $testAnsData;

    lightBoxView = $('<div class="light-box">' +
        '<button type="button" class="light-box-close"><i class="icon-close"></i></button>' +
        '<div class="light-box-overlay"></div>' +
        '<div class="light-box-list"><div class="light-box-slides"></div></div>' +
        '</div>');

    function compare_ans(slide_index, index) {
        var slide = $testAnsData[slide_index].split(':::'),
            slide_ans = slide[0],
            slide_text = slide[1],
            box = $body.find('.ft-quest').find('.ftq-item[data-i="'+ slide_index +'"]'),
            box_count = $body.find('.ft-quest').find('.ftq-item').length,
            right_count;

        if(index == slide_ans) {
            box.addClass('is-right');
        } else {
            box.addClass('is-wrong');
        }

        if (slide_index == box_count - 1) {
            right_count = $body.find('.ft-quest').find('.is-right').length;
            update_test_result(right_count);
        }

        box.find('.ftq-ans-res').html(slide_text);
        box.find('.ftq-next-slide').addClass('is-show');
        box.find('.k-loader').removeClass('is-show');
    }

    function update_test_result(count) {
        var post = $body.find('.single-post-fulltest'),
            id = post.attr('data-id'),
            action = post.find('.ft-test').attr('data-action-update'),
            result = post.find('.ft-res');

        $.ajax({
            type: 'POST',
            url: action,
            data: {
                test_post_id: id,
                count_answers: count
            },
            beforeSend: function () {

            },
            error: function (request, txtstatus, errorThrown) {},
            success: function (data) {
                var res = data.split(',,,');
                result.find('h4').find('span').html(count);

                result.find('dl[data-ind="'+res[1]+'"]').addClass('is-active');

                var fb_btn = result.find('.share-fb-button'),
                    s_title = $('h1').text(),
                    s_thumb = res[0],
                    s_link = window.location.href,
                    s_caption = 'LIVE.KARABAS.COM',
                    s_desc = fb_btn.attr('data-share-f') + ' ' + count + '! ' + fb_btn.attr('data-share-s'),
                    shareLink = '//www.facebook.com/sharer/sharer.php?u='+s_link+'&picture='+s_thumb+'&title='+s_title+'&caption='+s_caption+'&quote=&description='+s_desc;

                fb_btn.attr('data-share-link',shareLink);
            }
        });
    }


    function updateViews() {

        var update_action, linkId, postArr, idArr = {};

        if($body.find('.single-post-test').length){
            linkId = $body.hasClass('is-single') ? $body.find('.single-post-test').attr('id').split('-')[1] : '-';
        } else {
            linkId = $body.hasClass('is-single') ? $body.find('.single-post').attr('id').split('-')[1] : '-';
        }
        update_action = $body.find('.footer').attr('data-ajax') + '?action=update_post_view';
        postArr = $body.find('.post').not('.single-post').not('.is-rate-thumb');

        $.each(postArr,function(index, value){
            idArr[index] = {};
            idArr[index]["pid"] = $(this).attr('id').split('-')[1];
        });

        $.ajax({
            type: 'POST',
            url: update_action,
            data: {
                post_id: linkId,
                post_arr: idArr
            },
            beforeSend: function () {
                //console.log('start update');
            },
            error: function (request, txtstatus, errorThrown) {},
            success: function (data) {
                //console.log('success update');
                //console.log(data);
                var res = data.split(';');

                res.pop();

                for(var $j = 0; $j < res.length; $j++) {
                    var view = res[$j].split('|');
                    $body.find('#post-' + view[0]).find('.post-counter').html('<i class="icon-eye"></i> ' + view[1]);
                    console.log('postId: #post-' + view[0] + '; postCount: ' + view[1] + '.');
                }

            }
        });


    }

    $(document).ready(function () {
        $window = $(window);
        $body = $('body');
        $searchBox = $('.search-box');
        $homeSlider = $('.is-home').find('.post-list-first');

        if( ! $body.find('.single-some-page').length && ! $body.find('.single-post-fulltest').length ) {
            updateViews();
        }

        if ($body.hasClass('is-single')) {

            $gallery = $('.wpse-gallery-wrapper-block-slider');
            sliderCounts = $gallery.length;

            var $entry = $('.single-post').find('.entry-content');
                //imgList;

            lightBoxView.appendTo($body);

            $lightBox = $body.find('.light-box');

            lightBoxList = $('.gallery');

            //imgList = $entry.find('img').not('.gallery img');



            var lbCount = 0;

            lightBoxList.each(function () {
                var el = $(this);

                el.attr('data-number', lbCount);

                var aCount = 0;
                el.find('a').each(function () {
                    var a = $(this);

                    a.attr('data-link', lbCount + '' + aCount);

                    var thumb_url = a.attr('href'),
                        thumb_number = lbCount + '' + aCount,
                        thumb_title = $body.find('h1').text(),
                        thumb_slide = $('<div data-number="' + thumb_number + '" class="lb-slide"><img src="' + thumb_url + '" alt="' + thumb_title + '" /></div>');

                    thumb_slide.appendTo(lightBoxView.find('.light-box-slides'));
                    aCount++;

                });

                lbCount++;
            });

            //var bCount = 0;
            //imgList.each(function(){
            //      var img = $(this),
            //          a = img.parent();
            //
            //    a.attr('data-link', lbCount + '' + bCount);
            //
            //    var thumb_url = a.attr('href'),
            //        thumb_number = lbCount + '' + bCount,
            //        thumb_title = $body.find('h1').text(),
            //        thumb_slide = $('<div data-number="' + thumb_number + '" class="lb-slide"><img src="' + thumb_url + '" alt="' + thumb_title + '" /></div>');
            //
            //    thumb_slide.appendTo(lightBoxView.find('.light-box-slides'));
            //    bCount++;
            //});

            var lightBoxSlick = lightBoxView.find('.light-box-slides').slick({
                'adaptiveHeight': true,
                'prevArrow': '<button type="button" class="slick-prev"><i class="icon-a-left"></i></button>',
                'nextArrow': '<button type="button" class="slick-next"><i class="icon-a-right"></i></button>'
            });

            if (sliderCounts) {
                $gallery.each(function () {
                    var el = $(this);

                    el.find('.gallery').slick({
                        'adaptiveHeight': true,
                        'prevArrow': '<button type="button" class="slick-prev"><i class="icon-a-left"></i></button>',
                        'nextArrow': '<button type="button" class="slick-next"><i class="icon-a-right"></i></button>'
                    });

                });
            }


            $entry.on('click', 'a[data-link]', function () {
            //lightBoxList.on('click', 'a', function () {

                var link = $(this).attr('data-link'),
                    lbc = lightBoxSlick.find('div[data-number="' + link + '"]').attr('data-slick-index');

                lightBoxSlick.slick('slickGoTo', parseInt(lbc));

                $lightBox.addClass('is-open');

                $body.addClass('is-light-box-open');

                setTimeout(function () {
                    $lightBox.find('.light-box-list').addClass('is-open');
                }, 130);

                return false;

            });

            $lightBox.on('click', '.light-box-overlay, .light-box-close', function () {
                $lightBox.find('.light-box-list').removeClass('is-open');

                setTimeout(function () {
                    $lightBox.removeClass('is-open');
                    $body.removeClass('is-light-box-open');
                }, 130);
            });

            $body.on('keyup', function (e) {
                if (e.which == 37) {
                    $lightBox.find('.slick-prev').trigger('click');
                }
                if (e.which == 39) {
                    $lightBox.find('.slick-next').trigger('click');
                }
                if (e.which == 27) {
                    $lightBox.find('.light-box-list').removeClass('is-open');

                    setTimeout(function () {
                        $lightBox.removeClass('is-open');
                        $body.removeClass('is-light-box-open');
                    }, 130);
                }
            });

        }

        setTimeout(function () {
            if($searchBox.length){
                $searchBox.addClass('is-ready');
            }
        }, 2000);

        if($homeSlider.length){
            $homeSlider.on('init',function(event, slick){
                setTimeout(function(){
                    $.ajax({
                        type: 'post',
                        url: $homeSlider.attr('data-action'),
                        data: '',
                        beforeSend: function () {
                        },
                        error: function (request, txtstatus, errorThrown) {},
                        success: function (data) {
                            var slidebox = $('.slide-box-load');
                            slidebox.append(data);
                            slidebox.find('article').wrap('<div class="article-wrap"></div>');
                            slidebox.find('.article-wrap').each(function(){
                                $homeSlider.slick('slickAdd',$(this).html());
                            });
                        }
                    });
                },4000);
            });
            $homeSlider.slick({
                'adaptiveHeight': true,
                'dots': true,
                'autoplay': true,
                'autoplaySpeed': 6000,
                'infinite': true,
                'prevArrow': '<button type="button" class="slick-prev"><i class="icon-a-left"></i></button>',
                'nextArrow': '<button type="button" class="slick-next"><i class="icon-a-right"></i></button>',
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            arrows: false
                        }
                    }
                ]
            });
        }

        //  SOCIAL LINK in head nav
        var sb = $('.social-head');

        $body.find('.nav-social').find('li').each(function(){
            var el = $(this).clone(),
                link = el.find('a').clone();
            link
                .addClass(link.attr('title'))
                .appendTo(sb);
        });

        $body
            .on('click', '.nav-trigger', function () {
                $(this).parent().toggleClass('is-active');
            })
            .on('click', '.open-search', function () {
                var el = $(this),
                    searchbox = $('.search-box'),
                    sb = searchbox.find('.container');
                if (el.hasClass('is-active')) {
                    sb.removeClass('is-open');
                    setTimeout(function () {
                        searchbox.removeClass('is-open');
                        el.removeClass('is-active');
                        $body.removeClass('no-scroll');
                    }, 150);
                } else {
                    searchbox.addClass('is-open');
                    $body.addClass('no-scroll');
                    $('.wpdreams_asl_container').find('input[type="search"]').trigger('focus');
                    setTimeout(function () {
                        sb.addClass('is-open');
                        el.addClass('is-active');
                    }, 150);
                }
            })
            .on('click', '.close-search, .search-box-overlay', function () {
                $('.open-search').trigger('click');
            })
            .on('click', '.widget-most-view-nav button', function () {
                var btn = $(this),
                    viewType = btn.attr('data-w'),
                    nav = btn.parent(),
                    box = btn.parents('.widget-most-view');

                if (box.hasClass('is-loading') || btn.hasClass('is-active')) return false;

                if(btn.hasClass('is-load')){
                    nav.find('button').removeClass('is-active');
                    btn.addClass('is-active');
                    box.find('.wmv-item').removeClass('is-active');
                    box.find('.wmv-item[data-w="' + viewType + '"]').addClass('is-active');
                } else {

                    $.ajax({
                        type: 'post',
                        url: box.attr('data-action'),
                        data: {
                            view_arg: viewType
                        },
                        beforeSend: function () {
                            box.addClass('is-loading');
                        },
                        error: function (request, txtstatus, errorThrown) {},
                        success: function (data) {
                            nav.find('button').removeClass('is-active');
                            btn.addClass('is-active').addClass('is-load');
                            box.find('.wmv-item').removeClass('is-active');
                            //box.find('.wmv-item[data-w="' + viewType + '"]').addClass('is-active');
                            box.append('<div class="wmv-item is-active" data-w="'+viewType+'">'+data+'</div>');

                            box.removeClass('is-loading');
                        }
                    });

                }

                return false;
            });


        //  Polls

        var list = $('.vote-list'),
            form = $('.form-vote'),
            voteNum = parseInt(form.attr('data-length'));

        $body.find('.radio-select').each(function () {

            var rs = $(this),
                rsData = rs.attr('data-vars'),
                rsDataSplit = rsData.split(',');

            rsDataSplit.shift();

            rs.find('button').each(function () {
                var b = $(this),
                    i = b.attr('data-i'),
                    v = rsDataSplit[i];

                b.attr('data-c',v);
                //s.text(v);
            });

        });

        $body.on('click', '.show-result', function () {
            var b = $(this),
                ft = b.attr('data-f'),
                st = b.attr('data-s'),
                ul = $('.user-list');

            if(b.hasClass('is-admin')){
                window.location.href = b.attr('data-href');
            } else {
                if (b.hasClass('is-active')) {
                    list.removeClass('is-show-res');
                    ul.removeClass('is-show');
                    b
                        .removeClass('is-active')
                        .html(ft);

                } else {
                    list.addClass('is-show-res');
                    ul.addClass('is-show');
                    b
                        .addClass('is-active')
                        .html(st);
                }
            }





        });

        $body.find('.rate-chart').each(function () {
            var t = $(this),
                m_data = t.prev().attr('data-vars'),
                m_data_split = m_data.split(','),
                av = parseInt(t.parents('.is-rate-thumb').find('.count-numbers').text());

            m_data_split.shift();

            t.find('dl').each(function () {
                var dl = $(this),
                    ind = dl.attr('data-i'),
                    c = m_data_split[ind],
                    x = 170 * c / av,
                    sp = dl.find('span');

                sp
                    .attr('data-c', c)
                    .height(x);
            });
        });

        if($body.find('.radio-select').length){
            $body.find('.entry-header').addClass('button-inside');
        }

        $body.on('click', '.btn-set-vote', function () {
            var el = $(this),
                p = el.parent();

            if (p.hasClass('is-selected')) {
                p.removeClass('is-selected');
            } else {
                if (voteNum == 0) {
                    p.addClass('is-selected');
                } else {
                    if (list.find('.is-rate-thumb.is-selected').length < voteNum) {
                        p.addClass('is-selected');
                    }
                }
            }

            if (voteNum != 0) {
                if (list.find('.is-rate-thumb.is-selected').length == voteNum) {
                    list.addClass('is-disable');
                } else {
                    list.removeClass('is-disable');
                }
            }
        });

        $body.on('click', '.radio-select button', function () {

            var b = $(this),
                p = b.parent(),
                pp = b.parents('.is-rate-thumb');



            if (b.hasClass('is-active')) {
                b.removeClass('is-active');
                pp.removeClass('is-selected');
            } else {

                if(!list.hasClass('is-disable')){

                    p.find('button').removeClass('is-active');
                    b.addClass('is-active');

                    if (voteNum == 0) {
                        pp.addClass('is-selected');
                    } else {
                        if (list.find('.is-rate-thumb.is-selected').length < voteNum) {
                            pp.addClass('is-selected');
                        }
                    }

                } else {
                    if(pp.hasClass('is-selected')){
                        p.find('button').removeClass('is-active');
                        b.addClass('is-active');
                    }
                }

            }

            if (voteNum != 0) {
                if (list.find('.is-rate-thumb.is-selected').length == voteNum) {
                    list.addClass('is-disable');
                } else {
                    list.removeClass('is-disable');
                }
            }

        });

        $body.on('click', '.form-vote-btn', function () {

            if(form.hasClass('is-sending')) return false;

            var s_length = list.find('.is-rate-thumb.is-selected').length;

            if (s_length < 1) {

                form.find('.msg-err').html('Вы ничего не выбрали!').fadeIn();
                setTimeout(function () {
                    form.find('.msg-err').fadeOut(500, function () {
                        form.find('.msg-err').html('');
                    });
                }, 2500);

                return false;
            }

        });

        form.on('submit', function (e) {

            var votes = {},
                listSel = list.find('.is-rate-thumb.is-selected'),
                userMail = form.find('input[name="email"]').val(),
                newVarVote = $body.find('input[name="you_var"]').val(),
                counts = listSel.length,
                titleTag = $('h1');

            for (var i = 0; i < counts; i++) {
                votes[i] = {};

                if (list.find('.radio-select').length) {
                    votes[i]["selector"] = parseInt(jQuery(listSel[i]).find('.radio-select').attr('data-field-index'));
                    votes[i]["val_form"] = jQuery(listSel[i]).find('.radio-select').find('.is-active').attr('data-i');
                } else {
                    votes[i]["selector"] = parseInt(jQuery(listSel[i]).find('.btn-set-vote').attr('data-field-index'));
                    votes[i]["val_form"] = '0';
                }

            }

            var formData = {
                id_post: form.attr('data-id'),
                vote_lists: votes,
                count: counts,
                form_isset: list.find('.radio-select').length ? 1 : 0,
                user_mail: userMail,
                new_vote_var: newVarVote == '' ? '' : newVarVote,
                title: titleTag.text(),
                token_url: titleTag.attr('data-link')
            };

            $.ajax({
                type: 'POST',
                url: form.attr('action'),
                data: formData,
                beforeSend: function () {
                    form.addClass('is-sending');
                    //console.log(formData);
                },
                error: function (request, txtstatus, errorThrown) {

                },
                success: function (data) {

                    //console.log(data);

                    form.removeClass('is-sending').addClass('is-sending-complete');

                    form.find('.form-vote-float').after($(data));

                    form.find('input').val('');

                    $body.find('input[name="you_var"]').val('');

                    list.find('.is-rate-thumb').removeClass('is-selected');

                    list.find('.radio-select').find('button').removeClass('is-active');

                }
            });

            e.preventDefault();

        });



        //  Tests

        $body
            .on('click', '.test-quest-list .test-button button', function () {
                var el = $(this),
                    p = el.parents('.test-quest-card'),
                    pp = p.parent(),
                    card_l = pp.find('.test-quest-card').length,
                    ind_p = parseInt(p.attr('data-i')),
                    ind_b = parseInt(el.attr('data-i')),
                    ind_n = ind_p + 1;

                if (p.hasClass('is-good') || p.hasClass('is-error')) {
                    return false;
                }

                var list = $('.tqc'),
                    li = list.find('li[data-i="' + ind_p + '"]'),
                    text = li.attr('data-a'),
                    ind_a = parseInt(li.attr('data-b'));

                p.find('.test-ans').html(text);

                if (ind_a == ind_b) {
                    p.addClass('is-good');
                    var new_good = el.find('img').attr('data-win');
                    el.find('img').attr('src', new_good);
                    p.find('.next-slide').fadeIn();
                }
                else {
                    p.addClass('is-error');
                    var new_wrong = el.find('img').attr('data-wrong');
                    el.find('img').attr('src', new_wrong);
                    p.find('.next-slide').fadeIn();
                }

                p.find('.next-slide').attr({
                    'data-card': card_l,
                    'data-ind': ind_p,
                    'data-n-ind': ind_n
                });
            })
            .on('click','.next-slide',function(){
                var b = $(this),
                    ind_p = b.attr('data-ind'),
                    ind_n = b.attr('data-n-ind'),
                    card_l = b.attr('data-card');

                if (ind_p == card_l) {

                    var ppp = $('.test-quest-list'),
                        pr = $('.test-quest-res'),
                        sh = pr.next(),
                        count = ppp.find('.is-good').length;

                    pr.find('.name').find('span').html(count);

                    var sentData = {
                        id_post: parseInt($('.single-post-test').attr('data-id')),
                        res_count: count
                    };

                    $.ajax({
                        type: 'POST',
                        url: $('.test-quest').attr('data-action'),
                        data: sentData,
                        beforeSend: function () {

                        },
                        error: function (request, txtstatus, errorThrown) {

                        },
                        success: function (data) {

                            ppp.slideUp();
                            pr.slideDown();
                            sh.slideDown();
                            $('html,body').stop().animate({scrollTop: $('.test-quest').offset().top - 50}, 500);

                            var s_title = $('h1').text(),
                                s_thumb = data,
                                s_link = window.location.href,
                                s_caption = 'LIVE.KARABAS.COM',
                                s_desc = pr.attr('data-share-f') + ' ' + count + '! ' + pr.attr('data-share-s'),
                                shareLink = '//www.facebook.com/sharer/sharer.php?u='+s_link+'&picture='+s_thumb+'&title='+s_title+'&caption='+s_caption+'&quote=&description='+s_desc;

                            $('#fbShareBtn').on('click',function(){
                                window.open(shareLink, "pop", "width=600, height=400, scrollbars=no");
                                return false;
                            });
                        }
                    });

                } else {

                        var pp = $('.test-quest-list');
                        pp.find('.test-quest-card').removeClass('is-current');
                        pp.find('.test-quest-card[data-i="' + ind_n + '"]').addClass('is-current');
                }

            });



        //  Responsive youtube

        $body.find('.entry-content').find('iframe').each(function(){
            var el = $(this);
            if (el.attr('src').match(/youtube/)) {
                el.parent().addClass('is-youtube')
            }
        });




        $body.on('click','.e-vote-calc-link',function(){

            var btn = $(this),
                card_box = $('.e-vote-cards'),
                recalc_action = card_box.attr('data-action'),
                recalc_id = parseInt(card_box.attr('data-id')),
                votes_list = $('#approve-table'),
                card_array = {};

            if(btn.hasClass('is-loading')) return false;

            card_box.find('.evc-item').each(function(){
                var el = $(this),
                    el_index = el.attr('data-row-index'),
                    el_count = votes_list.find('span[data-card-index="'+el_index+'"]').length;

                el.find('.evc-item-count').find('span').html(el_count);

                if(el.find('.evc-item-vars').length){
                    var evc = el.find('.evc-item-vars'),
                        evc_text = '';

                    evc.find('span').each(function(){
                        var span = $(this),
                            span_ind = span.attr('data-i'),
                            span_count = votes_list.find('span[data-card-var-index="'+el_index+ '-' + span_ind + '"]').length;

                        span.find('sub').html(span_count);
                        evc_text += ',' + span_count;
                    });

                    el.attr('data-vars',evc_text);

                }

            });

            for (var i = 0; i < card_box.find('.evc-item').length; i++) {

                var el = card_box.find('.evc-item').eq(i),
                    el_index = el.attr('data-row-index'),
                    el_count = votes_list.find('span[data-card-index="'+el_index+'"]').length;

                card_array[i] = {};

                if (card_box.find('.evc-item-vars').length) {
                    card_array[i]["card_index"] = parseInt(el_index) + 1;
                    card_array[i]["card_vote_count"] = el_count;
                    card_array[i]["card_vote_form_count"] = el.attr('data-vars');
                } else {
                    card_array[i]["card_index"] = parseInt(el_index) + 1;
                    card_array[i]["card_vote_count"] = el_count;
                    card_array[i]["card_vote_form_count"] = 0;
                }

            }

            var sentData = {
                update_id: recalc_id,
                update_arr: card_array,
                update_arr_count: card_box.find('.evc-item').length
            };

            $.ajax({
                type: 'POST',
                url: recalc_action,
                data: sentData,
                beforeSend: function () {
                    btn.addClass('is-loading');
                    console.log(sentData);
                },
                error: function (request, txtstatus, errorThrown) {
                    console.log('error');
                },
                success: function (data) {
                    //console.log(data);
                    btn.removeClass('is-loading');
                }
            });

        });



        $body.on('click','.add-to-arr',function(){

            var btn = $(this),
                btn_action = btn.attr('data-action'),
                //recalc_id = parseInt(card_box.attr('data-id')),
                votes_list = $('#approve-table'),
                card_array = {};

            if(btn.hasClass('is-loading')) return false;

            $.ajax({
                type: 'POST',
                url: btn_action,
                data: {
                    post_year: parseInt(btn.attr('data-year'))
                },
                beforeSend: function () {
                    btn.addClass('is-loading');
                },
                error: function (request, txtstatus, errorThrown) {
                    console.log('error');
                },
                success: function (data) {
                    console.log(data);
                    btn.removeClass('is-loading');
                }
            });

        });
        $body.on('click','.remove-to-arr',function(){

            var btn = $(this),
                btn_action = btn.attr('data-action'),
                //recalc_id = parseInt(card_box.attr('data-id')),
                votes_list = $('#approve-table'),
                card_array = {};

            if(btn.hasClass('is-loading')) return false;

            $.ajax({
                type: 'POST',
                url: btn_action,
                data: '',
                beforeSend: function () {
                    btn.addClass('is-loading');
                },
                error: function (request, txtstatus, errorThrown) {
                    console.log('error');
                },
                success: function (data) {
                    console.log('remove complete');
                    btn.removeClass('is-loading');
                }
            });

        });

        $body.on('click','.e-vote-nav button',function(){
            var btn = $(this);
            if(!btn.hasClass('is-active')){
                var tabBlock = $('.e-vote-tabs');
                btn.parent().find('button').removeClass('is-active');
                btn.addClass('is-active');
                tabBlock.find('.e-vote-tab').removeClass('is-active');
                tabBlock.find('.e-vote-tab[data-tab="'+btn.attr('data-tab')+'"]').addClass('is-active');

            }
        });

        $body.on('click', '.share-fb-button', function () {
            var link = $(this).attr('data-share-link');
            window.open(link, "pop", "width=600, height=400, scrollbars=no");
            return false;
        });


        //$('#updateDateField').on('click',function(){
        //    var up_action = $(this).attr('data-action');;
        //    $.ajax({
        //        type: 'POST',
        //        url: up_action,
        //        data: '',
        //        beforeSend: function () {
        //            //form.addClass('is-sending');
        //            //console.log(formData);
        //        },
        //        error: function (request, txtstatus, errorThrown) {
        //            console.log('error');
        //        },
        //        success: function (data) {
        //            console.log('complete');
        //        }
        //    });
        //    return false;
        //});

        //  New Tests
        $body.on('change', '.ftq-item input',  function(){
            var post = $body.find('.single-post-fulltest'),
                id = post.attr('data-id'),
                start = post.find('.ft-test').attr('data-action'),
                action = post.find('.ft-test').attr('data-action-update'),
                slide = $(this).parents('.ftq-item'),
                slide_index = slide.index(),
                index = parseInt($(this).parent().index()) + 1;

            slide.find('input').attr('disabled',true);

            slide.find('.k-loader').addClass('is-show');

            if (slide.hasClass('is-first')) {

                $.ajax({
                    type: 'POST',
                    url: start,
                    data: {
                        test_post_id: id
                    },
                    beforeSend: function () {},
                    error: function (request, txtstatus, errorThrown) {},
                    success: function (data) {
                        $testAnsData = data.split(',,,');
                        compare_ans(slide_index, index);
                    }
                });

            }

            else {
                compare_ans(slide_index, index);
            }
        });

        $body.on('click','.ftq-next-slide',function(){
            var btn = $(this),
                bpar = btn.parents('.ftq-item');

            bpar.addClass('is-complete');

            setTimeout(function(){
                if( btn.hasClass('is-res') ) {
                    $body.find('.ft-res').slideDown(500,function(){
                        $('body,html').stop().animate({scrollTop: $body.find('.ft-res').offset().top}, 500);
                    });
                } else {
                    btn.parents('.ftq-item').next().slideDown(500);
                    $('body,html').stop().animate({scrollTop: bpar.offset().top}, 500);
                }
            },100);

        });


        $body.on('submit','#social_subscribe-form',function(e){
            //console.log(e);
            //e.preventDefault();
            $.ajax({
                type: 'POST',
                url: e.currentTarget.action,
                data: '',
                beforeSend: function () {
                    $body.removeClass('no-smm');
                    $body.find('#smm').attr('hidden',true);
                },
                error: function (request, txtstatus, errorThrown) {

                },
                success: function () {

                    console.log('subscribe later');

                }
            });
            e.preventDefault();
        });
    });


}(jQuery));
